"use strict";
/**
 * Types for Event and Round layout configs (EventDataLayout.json, RoundDataLayout.json).
 * Optional fields are used when not every layout item has them.
 */
Object.defineProperty(exports, "__esModule", { value: true });
